import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { fetchActivityLog } from '../lib/bridge';
import { LoadingState } from '../components/ui/LoadingState';
import { ErrorState } from '../components/ui/ErrorState';
import { EmptyState } from '../components/ui/EmptyState';
import { Card } from '../components/ui/Card';

export function ActivityLogPage() {
  const query = useQuery({ queryKey: ['activityLog'], queryFn: () => fetchActivityLog(50) });

  if (query.isLoading) return <LoadingState label="Loading activity log…" />;
  if (query.isError) {
    return <ErrorState message={query.error instanceof Error ? query.error.message : 'Could not load the activity log.'} onRetry={() => query.refetch()} />;
  }
  if (!query.data?.ok) {
    return <ErrorState message={query.data?.message || 'Could not load the activity log.'} onRetry={() => query.refetch()} />;
  }

  return (
    <div className="space-y-4">
      <div>
        <Link to="/settings/team" className="inline-flex items-center gap-1.5 text-sm font-semibold text-gold-300 hover:text-gold-200">
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Team
        </Link>
        <h1 className="mt-2 text-2xl font-extrabold tracking-tight text-white">Activity Log</h1>
      </div>

      {(query.data.items?.length ?? 0) === 0 && <EmptyState>No activity recorded yet.</EmptyState>}

      {(query.data.items?.length ?? 0) > 0 && (
        <Card padded={false}>
          <ul className="divide-y divide-ink-border">
            {query.data.items!.map((item, i) => (
              <li key={i} className="space-y-0.5 p-3.5 text-sm">
                <p className="text-slate-200">
                  <span className="font-semibold text-white">{item.name}</span> — {item.action}
                  {item.entityType ? ` (${item.entityType} ${item.entityId})` : ''}
                </p>
                {item.details && <p className="text-slate-400">{item.details}</p>}
                <p className="text-xs text-slate-500">{item.timestamp}</p>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
}
